import { useState, useCallback } from 'react';

const useFormData = (initialFormData) => {
  const [formData, setFormData] = useState(initialFormData || {});
  const [formErrors, setFormErrors] = useState({});

  const handleCheckbox = useCallback(
    (e) => {
      e.persist();
      setFormData((prevState) => {
        return {
          ...prevState,
          [e.target.name]: e.target.checked,
        };
      });
    },
    [setFormData]
  );

  const handleErrors = useCallback(
    (error) => {
      setFormErrors((prevState) => {
        return {
          ...prevState,
          ...error,
        };
      });
    },
    [setFormErrors]
  );

  const removeFormError = useCallback(
    (fieldName) => {
      setFormErrors((prevState) => {
        const newState = { ...prevState };
        delete newState[fieldName];
        return newState;
      });
    },
    [setFormErrors]
  );

  const handleInputChange = useCallback(
    (e) => {
      const { name, value, maxLength, step } = e.target;
      e.persist();
      removeFormError(name);
      setFormData((prevState) => {
        return {
          ...prevState,
          [name]: value,
        };
      });

      //display error if value is greater than character limit
      if (maxLength && value.length === maxLength && name !== 'sku') {
        handleErrors({
          [name]: `You have reached the ${maxLength
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} character limit.`,
        });
      }
      //price errors
      if (step === '.01') {
        if (value < 0) {
          handleErrors({
            [name]: `Price cannot be less than 0.`,
          });
        }
        const valid = /^\d+(\.\d{1,2})?$/.test(value);
        if (!valid && value !== '') {
          handleErrors({
            [name]: `Price can only have two decimal points.`,
          });
        }
      }
    },
    [removeFormError, setFormData, handleErrors]
  );

  const resetField = useCallback(
    (fieldName) => {
      setFormData((prevState) => {
        return {
          ...prevState,
          [fieldName]: '',
        };
      });
    },
    [setFormData]
  );

  return {
    handleInputChange,
    handleCheckbox,
    handleErrors,
    resetField,
    setFormData,
    setFormErrors,
    formData,
    formErrors,
    removeFormError,
  };
};

export default useFormData;
